/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlaylistsIdRouteImport } from './routes/playlists.$id'

const ManageLazyRouteImport = createFileRoute('/manage')()

const ManageLazyRoute = ManageLazyRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/manage.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const PlaylistsIdRoute = PlaylistsIdRouteImport.update({
  id: '/playlists/$id',
  path: '/playlists/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/playlists.$id.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/manage': typeof ManageLazyRoute
  '/playlists/$id': typeof PlaylistsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/manage': typeof ManageLazyRoute
  '/playlists/$id': typeof PlaylistsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/manage': typeof ManageLazyRoute
  '/playlists/$id': typeof PlaylistsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/manage' | '/playlists/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/manage' | '/playlists/$id'
  id: '__root__' | '/' | '/manage' | '/playlists/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ManageLazyRoute: typeof ManageLazyRoute
  PlaylistsIdRoute: typeof PlaylistsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playlists/$id': {
      id: '/playlists/$id'
      path: '/playlists/$id'
      fullPath: '/playlists/$id'
      preLoaderRoute: typeof PlaylistsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManageLazyRoute: ManageLazyRoute,
  PlaylistsIdRoute: PlaylistsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
